<!-- Translated: skip -->
<template>
  <div class="period-confirmation-viewer">
    <div v-if="period || true">
      <span :class="period ? '' : 'disabled'">
        <OutlineButton
          label="Ändra datum"
          icon="edit-blue"
          :iconscale="1.5"
          @click="openPriceList(unit)"
          v-if="!small"
        />
      </span>

      <!--<<div class="price-viewer max-mobile" v-if="!small">
        Pris
        <b>{{(cartAccomodationObject && period && period.price) | currency}}</b>
      </div>-->

      <!--<span v-if="!small"><br /><br /></span>-->
    <div :class="{'period-wrapper': true, disabled: (period && !period.free)}">
      <div class="period-viewer" v-if="period">
        <div class="week-viewer">
          v.{{period.date_arrival | date('week')}}
        </div>
        <icon name="calendar-blue" :scale="2.5">
        </icon>
        <b>{{[period.date_arrival, period.date_departure] | dateRange('weekday', ' - ') | capitalize}}</b><br />
        {{[period.date_arrival, period.date_departure] | dateRange('long', ' - ')}}
      </div>
      <div class="period-viewer" v-else>
        <div class="week-viewer">
          ...
        </div>
        <icon name="calendar-blue" :scale="2.5">
        </icon>
        <b v-if="checkAvailability">Laddar priset...</b>
        <b v-if="!checkAvailability">Laddar...</b><br />
        ...
      </div>

      <div class="price-viewer" v-if="!small">
        Pris
        <b v-if="cartAccomodationObject && period && period.price">{{(cartAccomodationObject && period && period.price) | currency}}</b>
        <b v-else>...</b>
      </div>

      <div style="clear:both;"></div>

    </div>

    <div v-if="mandatory_cleaning_price" style="clear:both;"></div>
    <div class="alert" v-if="mandatory_cleaning_price">
      <p>Detta boende har obligatoriskt slutstäd. Kostnaden ({{mandatory_cleaning_price / 2 | currency}} med RUT-avdrag) tillkommer utöver boendepriset.</p>
    </div>

    <div v-if="special_message" style="clear:both;"></div>
    <div class="alert" v-if="special_message" v-html="special_message">
    </div>

    <div v-if="not_available_reason" style="clear:both;"></div>
    <div class="alert" v-if="not_available_reason">
      <p>{{ not_available_reason }} <a href="#" v-if="!updating" @click.stop.prevent="fetch()">Testa igen</a>.</p>
    </div>


    </div>
    <div v-if="!period && false">
      Laddar information...
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import { mapMutations, mapGetters } from 'vuex';
import moment from 'moment';

import OutlineButton from '@/components/components/OutlineButton';
import accomodationIndex from '@/mixins/accomodationIndex';

export default {
  props: {
    unit: {},
    arrival: {},
    departure: {},
    small: {
      default: false,
    },
    checkAvailability: {
      default: true,
    },
  },
  mixins: [accomodationIndex],
  components: {
    OutlineButton,
  },
  data() {
    return {
      cartAccomodationObject: {},
      adults: 0,
      youths: 0,
      children: 0,
      cartObject: {},
      period: null,
      interval: null,
      updating: false,
      mandatory_cleaning_price: 0,
      special_message: '',
      not_available_reason: '',
    };
  },
  mounted() {
    this.updating = true;
    this.fetch();
  },
  computed: {
    ...mapGetters([
      'cart',
    ]),
    noOfVisitors() {
      return this.adults + this.youths + this.children;
    },
  },
  watch: {
    arrival: function a() {
      if (!this.updating) {
        this.updating = true;
        this.fetch();
      }
    },
  },
  methods: {
    ...mapMutations([
      'confirmAccomodation',
      'openModal',
    ]),
    fetch() {
      this.interval = setInterval(() => {
        if (this.unit && this.unit.pool_lid) {
          clearInterval(this.interval);
          this.updating = false;
          API.get(`/units/${this.unit.pool_lid}/${this.unit.unit_lid}/prices/${this.arrival}/${this.departure}`).then((result) => {
            let price = {};
            let foundFree = 0;

            /* eslint-disable */
            for (let i in result.data.accomodations.prices_extra) {
              if (result.data.accomodations.prices_extra.hasOwnProperty(i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_extra[i].period;
                  foundFree = result.data.accomodations.prices_extra[i].free;
                }
              }
            }

            for (let i in result.data.accomodations.prices_special) {
              if (result.data.accomodations.prices_special.hasOwnProperty(i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_special[i].period;
                  foundFree = result.data.accomodations.prices_special[i].free;
                }
              }
            }

            for (let i in result.data.accomodations.prices) {
              if (result.data.accomodations.prices.hasOwnProperty(i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices[i];
                  foundFree = result.data.accomodations.prices[i].free;
                }
              }
            }

            for (let i in result.data.accomodations.prices_summer) {
              if (result.data.accomodations.prices_summer.hasOwnProperty(i)) {
                if (!foundFree) {
                  price = result.data.accomodations.prices_summer[i];
                  foundFree = result.data.accomodations.prices_summer[i].free;
                }
              }
            }

            if (result.data.mandatory_cleaning) {
              this.mandatory_cleaning_price = Math.round(parseFloat(result.data.mandatory_cleaning.aprice));
            } else {
              this.mandatory_cleaning_price = 0;
            }

            if (result.data.special_message) {
              this.special_message = result.data.special_message;
            } else {
              this.special_message = '';
            }

            this.period = price;

            if (this.checkAvailability) {
              let url = `/units/${this.unit.pool_lid}/${this.unit.unit_lid}/check-availability/${this.arrival}/${this.departure}`;
              if (this.$store.state.lockingCode) {
                url = `${url}/${this.$store.state.lockingCode}`;
              }

              API.get(url).then((result) => {
                const period = Object.assign({}, this.period);
                period.available = result.success;
                period.not_available_reason = result.reason;

                if (!result.success) {
                  this.not_available_reason = result.reason;
                } else {
                  this.not_available_reason = '';
                }

                this.$emit('gotprice', period);
              });

            } else {
              this.mandatory_cleaning_price = 0;

            }
          });
        }
      }, 50);
    },
    showModal() {
      return this.$route.params.pool;
    },
    addToCart() {
      if (this.noOfVisitors <= 0) {
        this.openModal(['GeneralModal', {
          title: 'Välj antal personer',
          content: '<p>För att det ska bli lättare i nästa steg behöver du välja hur många personer i olika åldrar ni är.</p>',
        }]);
        return false;
      }

      if (this.noOfVisitors > this.cartAccomodationObject.capacity) {
        this.openModal(['GeneralModal', {
          title: 'Många resenärer',
          content: `<p>Du har valt att ni är totalt ${this.noOfVisitors} personer. Detta boende har kapacitet för ${this.cartAccomodationObject.capacity} personer.</p>`,
        }]);
        return false;
      }

      this.confirmAccomodation({
        adults: this.adults,
        youths: this.youths,
        children: this.children,
      });

      this.$router.push({ name: 'addons' });

      return true;
    },
    changeAdults(value) {
      this.adults = value;
    },
    changeYouths(value) {
      this.youths = value;
    },
    changeChildren(value) {
      this.children = value;
    },
    moment(date, format) {
      const string = moment(date).format(format);
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    validated() {
      return this.noOfVisitors;
    },
    openPriceList(unit) {
      if (this.$route.name === 'confirm-accomodation') {
        this.$router.push({ path: `/boenden/bekrafta/pris/${unit.slug}?flow=boenden/bekrafta&no=${this.currentRealAccomodationIndex}` });
      } else {
        this.$router.push({ path: `/boenden/pris/${unit.slug}?flow=boenden&no=${this.currentRealAccomodationIndex}` });
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.disabled
  disabled()

.alert
  border-radius 2px
  padding 15px 27px
  margin-top: 0
  margin-bottom: 20px
  background-color: #fff4d7
  border: 1px solid #ffe67d
  margin-top 20px
  p
    margin-bottom: 0

.outline-button
  border-radius 4px
  background-color #ffffff
  border solid 1px light-blue-grey
  font-family Interstate
  font-size 11px
  font-weight bold
  color deep-sea-blue
  text-transform uppercase
  text-decoration none
  padding 8px 12px 5px
  display inline-block
  width auto
  margin-bottom: 15px
  +max-mobile()
    float: left;

.tighter
  .period-wrapper
    width: 100%
    display: block;
    float: left;
    margin-bottom: 20px
  margin-bottom 20px
  .outline-button
    margin-bottom 20px
    +max-tablet()
      float: left;
      margin-left: 10px
  .alert
    margin-top 0

.period-wrapper
  display: block;
  width: 100%
  +max-tablet()
    float: left;
    margin-left: 0px

.period-viewer
  font-size 15px
  min-width 250px
  position relative
  display: inline-block;
  float: left;
  text-align: left
  +max-mobile()
    float: left;
    margin-left: 10px

  .week-viewer
    uppercase()
    position absolute
    left 0
    top 13px
    width: 36px;
    height: 11px;

    font-size: 11px;
    font-weight: bold;
    text-align: center;
    color: #005580;
  .icon--calendar-blue
    float left
    margin-right 10px
    position: relative;
    top: -3px

.price-viewer
  font-size 12px
  font-weight 300
  color #9e9e9e
  display: inline-block;
  position: relative;
  top: 10px;
  margin-right: 0px
  float: right;
  +max-mobile()
    float: left;
    margin-top: 15px
    margin-left: 10px
  +max-tablet()
    margin-top: 5px
    float: left;


  b
    font-size 26px
    font-weight bold
    letter-spacing 0.3px
    color #262626
    display inline-block
    margin-left 10px
    +max-tablet()
      font-size: 22px
</style>



// WEBPACK FOOTER //
// AccomodationPeriodConfirm.vue?6d11fcac